import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import OverlayGeneric from '../../components/Overlay/OverlayGeneric';
import OverlayTitle from '../../components/Petition/OverlayTitle';
import PartnerDescription from '../../components/Overlay/CustomDescription';

import { setOverlayPetitionVisible } from './actions';

const Overlay = props => (
    <OverlayGeneric
        aboutUsComponent={PartnerDescription}
        aboutUsContent={{ description: props.description }}
        allowScroll={true}
        description={props.description}
        isActionChoiceOverlay={props.isActionChoiceOverlay}
        isMobileResolution={props.isMobileResolution}
        isPartnerOrPublisherOverlay={true}
        isVisible={props.isVisible}
        logo={props.logo}
        logoComponent={OverlayTitle}
        name={props.name}
        setOverlayVisible={props.setOverlayPetitionVisible}
        title=""
        transitionType={props.transitionType}
    />
);

Overlay.propTypes = {
    description: PropTypes.string,
    isActionChoiceOverlay: PropTypes.bool,
    isMobileResolution: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    logo: PropTypes.string,
    name: PropTypes.string,
    setOverlayPetitionVisible: PropTypes.func.isRequired,
    transitionType: PropTypes.string.isRequired
};

export default connect(
    state => {
        return {
            description: state.widget.activeAction.text,
            isVisible: state.petition.isOverlayPetitionVisible,
            isPartnerOverlayTransitionRegular:
                state.widget.isPartnerOverlayTransitionRegular,
            isMobileResolution: state.widget.isMobileResolution
        };
    },
    { setOverlayPetitionVisible }
)(Overlay);
